<template>
  <BootstrapModal class="SimpleTextFieldModal"
    v-on="$listeners"

    @save="saveItem"
  >
    <FormInput
      class="form-element"
      v-model="$v.text.$model"

      id="text-field"
      :label="label"

      :vuelidate="$v"
      fieldName="text"
    />

    <template #title>
      {{ name ? editTitle : addTitle }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "./BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: {
    label: String,
    editTitle: String,
    addTitle: String,

    name: String,
    
    addCallback: Function,
    editCallback: Function,
  },
  components: {
    BootstrapModal,
    FormInput,
  },
  validations: {
    text: {
      required,
    },
  },
  data() {
    return {
      text: "",
    }
  },
  created() {
    if (this.name) {
      this.$v.text.$model = this.name
    }
  },
  methods: {
    saveItem() {
      this.$v.$touch()
      if (this.$v.$error) return;

      this.$handlePromise(async () => {
        if (this.name) {
          await this.editCallback(this.$v.text.$model)
        } else {
          await this.addCallback(this.$v.text.$model)
        }

        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.SimpleTextFieldModal {
  flex-basis: 500px;
}

</style>
